import { Box, Container, Typography } from "@mui/material";

export const TermsPage = () => {
  return (
    <Container component="main" sx={{ paddingY: 4 }}>
      <Box
        sx={{
          marginTop: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: 2,
        }}
      >
        <Typography component="h1" variant="h4" gutterBottom>
          Terms and Conditions – MiiraPOS
        </Typography>

        <Typography variant="body1">
          Effective Date: 01-Oct-2024
        </Typography>

        <Typography variant="h6">1. Acceptance of Terms</Typography>
        <Typography variant="body1">
          By using MiiraPOS (“the System”), provided by Miira Technologies Inc. (“we,” “our,” or “us”), you (“Store,” “User,” or “you”) agree to comply with these Terms and Conditions.
        </Typography>

        <Typography variant="h6">2. Use of Client Data</Typography>
        <Typography variant="body1">
          MiiraPOS collects customer information such as name, phone number, and address strictly for order processing, pickup notifications, and delivery coordination. This data is accessible only during the order lifecycle and is not available in reports or after 24 hours.
        </Typography>
        <Typography variant="body1">
          Store employees and operators are responsible for protecting customer data within their premises and must not share client information outside of legitimate order purposes. MiiraPOS is not responsible for misuse of data by individual users or stores.
        </Typography>

        <Typography variant="h6">3. Data Privacy and Security</Typography>
        <Typography variant="body1">
          We comply with applicable Canadian privacy laws, including PIPEDA, and apply security measures to protect stored data. MiiraPOS does not sell or share any personal data. We may use anonymized or aggregated data to improve our services.
        </Typography>

        <Typography variant="h6">4. System Availability and Data Loss</Typography>
        <Typography variant="body1">
          MiiraPOS strives to provide continuous service, but we do not guarantee uptime. We are not liable for service interruptions, system failures, or data loss. Users are responsible for maintaining local backups where necessary.
        </Typography>

        <Typography variant="h6">5. Client Responsibilities</Typography>
        <Typography variant="body1">
          Stores must comply with local privacy and data protection laws and ensure that their staff do not misuse or share customer information. MiiraPOS is not liable for any damages or liabilities resulting from the store’s internal use of data.
        </Typography>

        <Typography variant="h6">6. Aggregated Data Use</Typography>
        <Typography variant="body1">
          We may analyze anonymized usage data to improve system features, performance, and user experience. This data does not identify any individuals or businesses.
        </Typography>

        <Typography variant="h6">7. Changes to Terms</Typography>
        <Typography variant="body1">
          We reserve the right to update these Terms and Conditions at any time. Notification will be provided via email, in-app message, or through our website. Continued use of the system constitutes acceptance of the updated terms.
        </Typography>

        <Typography variant="h6">8. Limitation of Liability</Typography>
        <Typography variant="body1">
          Miira Corp. is not liable for any direct, indirect, incidental, or consequential damages arising from the use of MiiraPOS. This includes data breaches, third-party misuse, or unavailability of services.
        </Typography>

        <Typography variant="h6">9. Contact</Typography>
        <Typography variant="body1">
          For questions or concerns regarding these Terms, contact us at:
          <br />

          <br />
          Email: support@miirapos.com
          <br />
          Website: https://www.miirapos.com
        </Typography>
      </Box>
    </Container>
  );
};
